// extracted by mini-css-extract-plugin
export default {"wrapper":"security-settings-change-error_wrapper__YPa2v","opacity-transition":"security-settings-change-error_opacity-transition__bL36-"};